module.exports = __webpack_public_path__ + "static/media/grafik.98963e94.jpg";